var map = {
	"./BlockContextMenu.vue": 7241,
	"./BlockUsageWarningModal.vue": 52647,
	"./Canvas.vue": 28768,
	"./DocumentIframe.js": 94430,
	"./Gallery.vue": 84706,
	"./ModeAndViewportToolbar.vue": 57443,
	"./ToolbarTop.vue": 98278,
	"./VersionActions.vue": 34405,
	"./resizableMargin.js": 56672,
	"./tooltip.js": 22656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10571;